<template>
  <div style="padding: 10px">
    <el-form :model="busData" label-width="150px" :rules="rules">
      <el-form-item label="文件生成方式：" required>
        <el-select v-model="busData.fileGenerateType" class="form-item" placeholder="选择制作方式" clearable>
          <el-option v-for="item in makeTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="上传文件：" v-if="busData.fileGenerateType=='upload'">
        <frame-item v-model="busData.uploadFileIds" :item="uploadOptions"/>
      </el-form-item>

      <el-form-item label="选择报价模板：" v-if="busData.fileGenerateType=='system_generate'" required>
        <el-select v-model="busData.quoteTemplateId" class="form-item" placeholder="选择报价模板" clearable>
          <el-option v-for="item in quoteTemplateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择联系人：" v-if="busData.fileGenerateType=='system_generate'" required>
        <el-select v-model="busData.contactId" class="form-item" placeholder="选择联系人" clearable="true"
                   filterable="true" style="margin-right:20px ">
          <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <FrameButton :button="addContactBtn" :parent-data="parentData"></FrameButton>
      </el-form-item>

      <el-form-item label="已有报价单加载：">
        <el-select v-model="busData.quoteId" class="form-item" placeholder="选择报价单" clearable>
          <el-option v-for="item in quoteList" :key="item.id" :label="getQuoteLabel(item)" :value="item.id"></el-option>
        </el-select>
        <el-button style="margin-left: 20px" @click="loadQuoteItems()">加载内容</el-button>
        <el-button style="margin-left: 20px" @click="addOneProduct()">添加商品行</el-button>
      </el-form-item>
    </el-form>

    <el-row class="box">
      <el-col :span="9">{{ $t('quote.trade_name') }}</el-col>
      <el-col :span="1">{{ $t('quote.unit') }}</el-col>
      <el-col :span="2">{{ $t('quote.standard_price') }}</el-col>
      <el-col :span="1">{{ $t('quote.tax_rate') }}</el-col>
      <el-col :span="2">{{ $t('quote.sales_price') }}</el-col>
      <el-col :span="2">{{ $t('quote.discount_ratio') }}</el-col>
      <el-col :span="2">{{ $t('quote.number') }}</el-col>
      <el-col :span="5">{{ $t('quote.remark') }}</el-col>
    </el-row>

    <el-row v-for="item in busData.itemList" :key="item.product_ids" class="row" :gutter="25">
      <el-col :span="9">
        <el-cascader v-model="item.product_ids" :options="catalogWithProducts" style="width: 100%"
                     :show-all-levels="false" placeholder="选择商品名称"
                     :props="props" clearable filterable @change="onProductSelect(item)"/>
      </el-col>
      <el-col :span="1" class="tip">{{ item.unit }}</el-col>
      <el-col :span="2" class="tip">{{ item.market_price }}</el-col>
      <!--el-col :span="2" class="tip">{{ item.min_price }}</el-col-->
      <el-col :span="1" class="tip">{{ item.tax_rate }}</el-col>
      <el-col :span="2">
        <el-input v-model="item.sales_price" @change="changeSalesPrice(item)" placeholder="销售价" style="width: 100%"></el-input>
      </el-col>
      <el-col :span="2">
        <el-input v-model="item.discount_ratio" @change="changeDiscountRatio(item)" placeholder="折扣比例" style="width: 100%"></el-input>
      </el-col>
      <el-col :span="2">
        <el-input-number v-model="item.cnt" @change="calcTotalPrice()" :min="0" :max="200" placeholder="数量" style="width: 120px"></el-input-number>
      </el-col>
      <el-col :span="5">
        <el-input v-model="item.remark" class="w-percent-90" placeholder="备注"></el-input>
        <div class="close" @click="removeOneMaterial(item.nanoid)">
          <el-icon>
            <ElIconClose></ElIconClose>
          </el-icon>
        </div>
      </el-col>
    </el-row>

    <el-row style="margin-top: 15px">
      <el-col :span="9">
        <el-input type="textarea" class="quote-remark" v-model="busData.remark" placeholder="报价备注" style="width: 100%"
                  :autosize="true"></el-input>
      </el-col>
      <el-col :span="4" :offset="6" class="tax-amount">
        <span>税额：{{ this.busData.taxAmountFormat }}</span>
      </el-col>
      <el-col :span="3" class="tax-amount">
        <span>总金额：{{ this.busData.totalAmountFormat }}</span>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" style="width: 500px;;margin-top: 20px" @click="addQuote" :loading="loading">提交</el-button>
    </el-form-item>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

const messages = {
  zhCn: {
    label: '变量label',
    key: '变量key',
    input_type: '输入方式',
    input_value: '下拉框可选值',
    default_value: '默认值',
    remark: '输入提示',
    input_type_name: '用逗号分隔如：全款,二次付款',
    add_a_line: '添加一行',
    submit: '确认提交',
    check_page1: '第 ',
    check_page2: '个变量key不能为空',
    check_page3: '个输入方式不能为空',
    check_page4: '个可选值不能为空',
    success: '提交成功',
    error1: '提交失败,{msg}',
    error2: '查询失败,{msg}',
  },
  zhTw: {
    label: '變數label',
    key: '變數key',
    input_type: '輸入管道',
    input_value: '下拉清單可選值',
    default_value: '預設值',
    remark: '輸入提示',
    input_type_name: '用逗号分隔如：全款,二次付款',
    add_a_line: '添加一行',
    submit: '確認提交',
    check_page1: '第 ',
    check_page2: '個變數key不能為空',
    check_page3: '個輸入管道不能為空',
    check_page4: '個可選值不能為空',
    success: '提交成功',
    error1: '提交失敗,{msg}',
    error2: '查询失敗,{msg}'
  },
  en: {
    label: 'Variable label',
    key: 'Variable key',
    input_type: 'Input type',
    input_value: 'Input value',
    default_value: 'Default',
    remark: 'Input prompt',
    input_type_name: 'Separate with commas such as: fullPayment,secondaryPayment',
    add_a_line: 'Add a row',
    submit: 'Submit',
    check_page1: 'The ',
    check_page2: 'variable key cannot be empty',
    check_page3: 'input methods cannot be empty',
    check_page4: 'optional values cannot be empty',
    success: 'Submit success',
    error1: 'Submit fail,{msg}',
    error2: 'Select fail,{msg}',
  }
}
export default {
  name: "ChanceQuote",
  i18n: {messages},
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      addContactBtn: {
        "component": "button",
        "click": "jsOpenDialog",
        "label": "添加职员",
        "window": {
          "component": "frame/FrameForm",
          "type": "sales_chance_tab_contact_add",
          "title": "添加职员",
          "width": 600,
          "height": 600
        }
      },
      priceTips: false,
      dialogFormVisible: false,
      busData: {
        customerSealed: false,
        fileGenerateType: 'system_generate',
        uploadFileIds: [],
        taxAmount: 0,
        totalAmount: 0,
        taxAmountFormat: 0,
        totalAmountFormat: 0,
        contactId: '',
        chanceId: '',
        remark: '',
        itemList: [],
        contractVariableList: [],
        quoteTemplateId: ''
      },
      imageUrl: '',
      contactList: [],
      productAll: [],
      catalogWithProducts: [],
      makeTypeList: [{value: "system_generate", label: "从模板生成"}, {value: "upload", label: "上传文件"}],
      uploadOptions: {component: 'file_upload', limit: 1, accept: ".pdf,.xlsx,.docx,.xls,.doc"},
      quoteList: [],
      quoteTemplateList: [],
      loading: false,
      rules: {
        contactId: [{required: true, message: '', trigger: 'blur'}],
        quoteTemplateId: [{required: true, message: '', trigger: 'blur'}],
      }
    }
  },
  provide() {
    return {
      $fn: {
        reloadContact: () => {
          this.getCompanyContactList();
        }
      }
    }
  },
  created() {
    this.addFiveProduct()
    this.getCompanyContactList()
    this.getCatalogWithProducts()
    this.getQuoteTemplateList()
    this.getQuoteList()
  },
  methods: {
    async getCatalogWithProducts() {
      this.catalogWithProducts = await this.$http('crmProductCatalogService.getCatalogWithProducts')
      //从目录树里面获取所有产品，不要再从后端读一次
      this.productAll = []
      this.readProducts(this.catalogWithProducts)
    },
    readProducts(catalogList) {
      if (!catalogList || catalogList.length == 0) {
        return;
      }

      for (var i = 0; i < catalogList.length; i++) {
        var busObject = catalogList[i]
        if (busObject.is_product == true) {
          this.productAll.push(busObject);
        } else {
          this.readProducts(busObject.children)
        }
      }
    },
    getProductById(productId) {
      for (var i = 0; i < this.productAll.length; i++) {
        if (this.productAll[i].id == productId) {
          return this.productAll[i];
        }
      }
      return null;
    },
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()

    },

    clearPreData() {
      //清空表单数据
      this.busData.result = ''
      this.busData.remark = ''
      this.busData.itemList = []
      this.addFiveProduct();
      this.calcTotalPrice();
    },

    //获取联系人
    async getCompanyContactList() {
      let params = {chance_id: this.parentData.chance_id}
      this.contactList = await this.$http('crmChanceService.getCompanyContact', params)
    },
    //获取报价列表
    async getQuoteList() {
      let params = {chance_id: this.parentData.chance_id}
      this.quoteList = await this.$http('crmQuoteService.getChanceQuotes', params)
    },

    //获取报价明细
    async loadQuoteItems() {
      if (this.busData.quoteId == '') {
        return;
      }

      let params = {quote_id: this.busData.quoteId}
      let quoteData = await this.$http('crmQuoteService.getQuoteWithDetail', params)
      this.busData.itemList = quoteData.item_list || [];
      this.calcTotalPrice();
    },

    getQuoteLabel(item) {
      var amountFormat = this.formatMoney(item.total_amount);
      return item.quote_no + ' (' + amountFormat + ")";
    },
    changeSalesPrice(item) {
      if (!item.product_id) {
        this.$message.error("请先选择商品");
        return;
      }

      if (item.market_price == 0) {
        item.discount_ratio = 0
        return;
      }

      item.discount_ratio = parseInt(item.sales_price * 100 / item.market_price);
      this.calcTotalPrice();
    },
    changeDiscountRatio(item) {
      if (!item.product_id) {
        this.$message.error("请先选择商品");
        return;
      }

      if (item.market_price == 0) {
        item.sales_price = 0
        return;
      }

      item.sales_price = parseInt(item.market_price * item.discount_ratio / 100);
      this.calcTotalPrice();
    },
    //获取商品详情
    onProductSelect(item) {
      console.log("item.product_ids:")
      console.log(item.product_ids)
      if (!item.product_ids || item.product_ids.length == 0) {
        item.unit = "";
        item.market_price = 0;
        item.market_price_format = "";
        item.tax_rate = 0;
        item.sales_price = 0;
        item.discount_ratio = 0;
        item.cnt = 0;
        this.calcTotalPrice();
        return
      }

      var productId = item.product_ids[item.product_ids.length - 1]
      console.log("productId=" + productId)

      var product = this.getProductById(productId);
      if (!product) {
        return this.$message.error("未找到商品,id:" + productId);
      }

      item.product_id = product.id;
      item.unit = product.unit;
      item.market_price = product.market_price;
      item.market_price_format = this.formatMoney(item.market_price);
      item.tax_rate = product.tax_rate;

      this.calcTotalPrice();
    },
    //计算总价
    calcTotalPrice() {
      this.busData.totalAmount = 0;
      this.busData.taxAmount = 0;

      for (var i = 0; i < this.busData.itemList.length; i++) {
        var item = this.busData.itemList[i]

        if (item.product_id && item.sales_price && item.cnt) {
          var itemAmount = item.sales_price * item.cnt
          this.busData.totalAmount += itemAmount;
          this.busData.taxAmount += itemAmount * item.tax_rate / (100 + item.tax_rate);
        }

      }

      this.busData.taxAmountFormat = this.formatMoney(this.busData.taxAmount)
      this.busData.totalAmountFormat = this.formatMoney(this.busData.totalAmount)
    },
    //将数字转换成金额显示
    formatMoney(num) {
      num = num.toFixed(2);
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },
    async getQuoteTemplateList() {
      this.quoteTemplateList = await this.$http('crmDsService.getQuoteTemplates')
    },
    addQuote() {

      if (this.busData.fileGenerateType == 'upload') {
        if (this.busData.uploadFileIds == null || this.busData.uploadFileIds.length == 0) {
          return this.$message.error("未上传文件");
        }
        //只往后传第一个文件
        this.busData.uploadFileId = this.busData.uploadFileIds[0]
      }

      var a = 0;
      for (let i = 0; i < this.busData.itemList.length; i++) {
        let obj = this.busData.itemList[i]
        if (obj.product_id) {

          if (!obj.market_price) {
            return this.$message.error(`第${i + 1}行标准价不能为空`);
          }

          if (!obj.tax_rate) {
            return this.$message.error(`第${i + 1}行税率不能为空`);
          }

          if (!obj.sales_price) {
            return this.$message.error(`第${i + 1}行销售价不能为空`);
          }

          if (!obj.cnt) {
            return this.$message.error(`第${i + 1}行数量不能为空`);
          }

          a++;
          obj.has_data = true;
        }
      }

      if (a == 0) {
        return this.$message.error("报价数据不能为空");
      }

      this.busData.chanceId = this.parentData.chance_id;
      this.loading = true;

      this.$http('crmQuoteService.addQuote', this.busData).then(data => {
        this.loading = false;
        this.clearPreData();
        this.$fn.search();
        this.$fn.closeWindow();
      })
    },
    addFiveProduct() {
      for (let i = 0; i < 5; i++) {
        this.busData.itemList.push({
          nanoid: nanoid(),
          productDetails: {}
        })
      }
    },
    addOneProduct() {
      this.busData.itemList.push({
        nanoid: nanoid(),
        productDetails: {}
      })
    },
    removeOneMaterial(nanoid) {
      let index = this.busData.itemList.findIndex(item => item.nanoid === nanoid);
      this.busData.itemList.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>